/*
  JALA REVIEWS FEED
  -----------------
  Every review here appears on the interactive Reviews Wall (filterable, searchable, load-more).
  Paste in as many as you like — 2,000+ is fine (they load 12 at a time).

  Format, one per line:
    { n: "Name", r: 5, t: "Review text", d: "YYYY-MM-DD", s: "google" | "fresha", w: "Therapist (optional)" }

  Seeded with recent Fresha reviews. See SETUP-GUIDE.md for how to bulk-import Google & Fresha reviews.
*/
window.JALA_REVIEWS = [
  { n: "Gillian P", r: 5, s: "fresha", d: "2026-10-10", w: "Stacey", t: "Care and compassion of the staff was amazing made you feel like you were the only one there." },
  { n: "Natalie R", r: 5, s: "fresha", d: "2026-10-08", w: "Bec", t: "Fabulous treatment, salon and staff. See you next time! Thank you" },
  { n: "Sophie B", r: 5, s: "fresha", d: "2026-10-08", w: "Kimberly", t: "Such a relaxing experience!!!! Total Heaven" },
  { n: "Michael B", r: 5, s: "fresha", d: "2026-10-03", w: "Bec", t: "Bec is amazing, she is professional and has a kind and welcoming nature. Best experience, great way to take some time to rest and relax for a while. Thankyou Bec" },
  { n: "Pauline W", r: 5, s: "fresha", d: "2026-10-03", w: "Hannah", t: "Hannah is so professional & absolutely amazing at her job. I highly recommend booking in with her & you will see for yourself just fabulous she is. She always goes above and beyond to make your experience next level." },
  { n: "Bec P", r: 5, s: "fresha", d: "2026-10-02", w: "Hannah", t: "Magic hands and the ultimate relaxation, Thankyou beautiful Hannah" }
];
